import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

import event1 from "../../assets/img/event1.jpg";
import event2 from "../../assets/img/event2.jpg";
import event3 from "../../assets/img/event3.png";

const Events = () => {
  const { t } = useTranslation();
  const events = [
    {
      title: "MRO Middle East 2017",
      description:
        "GGAS Maintenance Tooling &amp; Equipments to participate in MRO Middle East 2017. The region's leading MRO exhibition and conference, come and meet us at booth 252B, Dubai World Trade Centre between 8-9 February.",
      img: event1,
    },
    {
      title: "MRO Middle East 2016",
      description:
        "GGAS Maintenance Tooling &amp; Equipments to participate in MRO Middle East 2016. The region's leading MRO exhibition and conference for commercial aviation maintenance. Stay tuned for more details.",
      img: event2,
    },
    {
      title: "India Aviation 2016",
      description:
        "GGAS Maintenance Tooling &amp; Equipments participated in India Aviation 2016. This was a part of starting its operations in India. Now we are more close to our Indian customers.",
      img: event3,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Events | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title="Events" t={t} />
      <section className="videoGallery sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h6>GGAS</h6>
            <h3>Our Events</h3>
          </div>
          <div className="eventsCard">
            {events.map((item) => {
              return (
                <div className="eventsItems" key={item}>
                  <div className="row">
                    <div className="col-lg-2">
                      <div className="eventFigure">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-lg-10">
                      <div className="eventContent">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Events;
